import { render } from "./App.vue?vue&type=template&id=a363e52e&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a363e52e&lang=scss&scoped=true"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.42_vue@3.5.42_typescript@4.6.4__webpack@5.110.3_postcss@8.5.28_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a363e52e"]])

export default __exports__